import React from "react";
import { NavDropdown, Dropdown } from "react-bootstrap";
import { _t } from "app/i18n/i18n";
import { Link } from "app/header/parts/Link";
import { FaIcon } from "lib/FaIcon";
import { isIntranetPath } from "lib/routing";
import { isAdminUser, isReadershipUser, isPublishUser } from "lib/entitlements";
import { auditLocationChange } from "lib/analytics/auditEvents";
import "./styles/desktop.css";

export function AccountDropdown() {
  return (
    <NavDropdown
      title={<FaIcon icon="fa fa-user-alt text-primary ml-1" />}
      variant="dark"
      className="position-static"
    >
      <GlobalLinks />
      {isIntranetPath() ? <IntranetLinks /> : <SignOutLink />}
    </NavDropdown>
  );
}

function auditClickOnMySubscriptions() {
  auditLocationChange(null, { payload: { location: { pathname: "/MySubscriptions" } } });
}

function GlobalLinks() {
  return (
    <>
      <ExternalLink
        href="/research/japi/subscription_handshake"
        icon="far fa-bell"
        label={_t("My Subscriptions")}
        onClick={auditClickOnMySubscriptions}
        target="_blank"
      />
      <Link
        to="/My_Reading_List"
        label={_t("My Reading List")}
        icon="fab fa-stack-overflow"
        className="nav-dropdown-item-custom"
      />{" "}
    </>
  );
}

function IntranetLinks() {
  return (
    <>
      {isReadershipUser() || isAdminUser() || isPublishUser() ? <Dropdown.Divider /> : null}

      {isReadershipUser() ? (
        <ExternalLink
          href="http://intranet.nomuranow.com/research/grp-usage-analytics"
          icon="far fa-chart-bar"
          label={_t("Readership")}
        />
      ) : null}

      {isAdminUser() ? (
        <ExternalLink href="/research/v1/admin/default.aspx" icon="fas fa-user-shield" label={_t("Admin")} />
      ) : null}

      {isPublishUser() ? <ExternalLink href="/research/v1/publish" icon="fas fa-upload" label={_t("Publish")} /> : null}
    </>
  );
}

function SignOutLink() {
  return (
    <>
      <Dropdown.Divider />
      <Link to="/Sign_Out" icon="fa fa-sign-out-alt" label={_t("Sign Out")} className="nav-dropdown-item-custom" />
    </>
  );
}

function ExternalLink({ className, href, icon, label, onClick, target }) {
  return (
    <NavDropdown.Item
      href={href}
      className={`nav-dropdown-item-custom ${className || ""}`}
      onClick={onClick}
      target={target}
      rel={target === "_blank" ? "noopener noreferrer" : undefined}
      data-testid="account-external-link"
    >
      <FaIcon icon={icon} className="ml-0 mr-3 mr-md-3" />
      {label}
    </NavDropdown.Item>
  );
}

// No changes needed; verify target/rel behavior and click analytics.
